import axios from "axios";
import { _api } from "../config/environment";
import history from "../config/history";

const axiosInstance = axios.create();
const refreshAxios = axios.create();

let refreshInFlight = null;
let isForcingLogout = false;

const REFRESH_PATH = "/auth/refresh/token";

async function refreshToken() {
  if (refreshInFlight) return refreshInFlight;

  const rft = localStorage.getItem("rft");
  if (!rft) return false;

  refreshInFlight = (async () => {
    try {
      // IMPORTANT: use refreshAxios (no interceptors) to avoid infinite recursion on 401.
      const refreshResponse = await refreshAxios.post(`${_api.url}${REFRESH_PATH}`, {
        refreshToken: rft,
      });
      const { data } = refreshResponse.data;
      return data;
    } catch (error) {
      return false;
    } finally {
      refreshInFlight = null;
    }
  })();

  return refreshInFlight;
  }

function forceLogout() {
  if (isForcingLogout) return;
  isForcingLogout = true;
  localStorage.removeItem("key");
  localStorage.removeItem("rft");
  localStorage.removeItem("staySignedIn");
  history.push("/login");
}


  axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;

      if (error.response?.status === 401) {
        // Never try to refresh on the refresh endpoint itself (prevents infinite loop).
        const requestUrl = originalRequest?.url || "";
        if (requestUrl.includes(REFRESH_PATH)) {
          forceLogout();
          return Promise.reject(error);
        }

        const errorMessage = error.response?.data?.message || '';
        if (errorMessage.includes('no longer a member') || errorMessage.includes('not a member')) {
          forceLogout();
          return Promise.reject(error);
        }

        // Try token refresh if not already retried
        if (!originalRequest._retry) {
          originalRequest._retry = true;

          try {
            const newToken = await refreshToken()

            if(!newToken) {
              forceLogout();
              return Promise.reject(null);
            }

            localStorage.setItem("key", newToken);
            axiosInstance.defaults.headers.common["Authorization"] = `Bearer ${newToken}`;
            originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
            return axiosInstance(originalRequest);
          } catch (refreshError) {
            // Refresh failed - logout
            forceLogout();
            return Promise.reject(refreshError);
          }
        } else {
          // Already retried once - logout
          forceLogout();
          return Promise.reject(error);
        }
      }

      return Promise.reject(error);
    }
  );


export default axiosInstance;